import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  emailChatPhoneKbSupport: {
    description: 'support option for email, chat, phone, and knowledge base',
    defaultMessage: 'Email, Live Chat, Phone, and Knowledge Base',
    id: 'c3P2CJ',
  },
  phoneSupport: {
    description: 'phone support indicator',
    defaultMessage: 'Phone',
    id: '0gfU9z',
  },
  emailSupport: {
    description: 'email support indicator',
    defaultMessage: 'Email',
    id: '4aF46A',
  },
  liveChatSupport: {
    description: 'live chat support indicator',
    defaultMessage: 'Live Chat',
    id: 'jHgC6i',
  },
  emailChatKbSupport: {
    description: 'support option for email, chat, and knowledge base',
    defaultMessage: 'Email, Live Chat, and Knowledge Base',
    id: 'zjuj8v',
  },
});
